import './Exam_ChartSt.scss';
import React, { useState, useEffect } from "react";
import HeaderTitle from "../comm/HeaderTitle";
import fnc from "../mymod/commFunction";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import {
  setRowIdx_pdf,
  setKind,
  setList_pdf_marking,
  setList_pdf_complete,
  setSelectedPage_pdf,
  setHeaderInfo,
  setHeader_dev,
} from "../reduxToolkit/redux";


const Exam_ChartSt = ({ testCode, stCode, setIsModal }) => {
 
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    dispatch(setHeader_dev("Exam2Main"));
  }, []);

  useEffect(() => {
    // const stCode = fnc.getCookie("stCode");
    // const testCode = selectedListItem.testCode;
    fncSelect_exam_report({stCode, testCode});
  }, []);

  const fncSelect_exam_report = ({ stCode, testCode }) => {
    fnc.sendAxios("/select/exam/report", { stCode, testCode }, (res) => {
      if (res) {
       const data = getRecords_dataList(res);
        setDataList(data);
      } else {
        console.log(res, "kuesbChartRoutes/fncSelect_exam_report");
      }
    });
  };

  function getRecords_dataList(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {
        let name = res[i].name;
        let score =  parseFloat(res[i].score).toFixed(1);
        let avg =  parseFloat(res[i].avgScore).toFixed(1);
        let sd = res[i]['stdDeviation'];
       // 모든 소수점 이하 자리가 0인 경우 정수로 변환
       score = (parseFloat(score) % 1 === 0) ? parseInt(score) : parseFloat(score);
       avg = (parseFloat(avg) % 1 === 0) ? parseInt(avg) : parseFloat(avg);
            
        records.push({
            name, score, avg , sd
        });
    }
    return records;
}

  
const CustomLabel = (props) => {

    const { x, y, width, value } = props;
    return (
      <text x={x + width / 2} y={y - 10} fill="#000" textAnchor="middle" dominantBaseline="middle">
        {value}
      </text>
    );
  };

  //==================================================================================
  return (
    <div className="Exam_ChartSt">
      {/* <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModal(false)} /> */}

    <div className="box-chart">
     <div style={{ width: "100%", height: '80%', marginTop: '3rem' }}>
        {dataList.length > 0 && <h1 className='chartTitle'>{dataList[0].name}의 점수</h1>}
        <ResponsiveContainer width="80%" height="100%">
        <BarChart
          data={dataList}
          margin={{ top: 60, right: 10, left: 70, bottom: 100 }}
          barCategoryGap="30%"
          barGap={24}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={false}>
            <Label value="" offset={-5} position="insideBottom" />
          </XAxis>
          <YAxis>
            <Label value="점수" angle={-90} position="insideLeft" style={{ textAnchor: 'middle' }} />
          </YAxis>
          {/* <Tooltip /> */}
          <Legend verticalAlign="bottom" align="center" wrapperStyle={{ transform: 'translateX(2rem)' }} />

          <Bar dataKey="score" fill="#8884d8" name="내 점수" barSize={24} label={<CustomLabel />} />
          <Bar dataKey="avg" fill="#82ca9d" name="평균" barSize={24} label={<CustomLabel />} />
        </BarChart>
      </ResponsiveContainer>
      </div> 

      </div>
    </div>
  );
};

export default Exam_ChartSt;
